import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { ToastrService } from 'ngx-toastr';
import { CommonUtilService } from '../../../../shared/services/CommonUtil.service';
import { ContactsService } from '../../../contacts/services/contacts.service';
import { RoDs } from '../../../../shared/services/rods.service';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { UniversalSearchModel } from '../../../../core/models/universal-search.model';
import { CompanyService } from '../../../companies/services/companies.service';
import { SavedSearches } from '../../../../shared/services/saved-searches.service';
import { saveAs } from 'file-saver';
import { RequestResearchModalComponent } from '../../../../shared/components/request-research-modal/request-research-modal.component';
import { UserService } from 'src/app/core/services/user.service';
import { AccountAttributesEnum, FeatureFlagsEnum } from 'src/app/shared/enums';
import { RequestBodyService } from 'src/app/shared/services';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { filter, switchMap } from 'rxjs/operators';
import {  MatDialog,  MatDialogConfig } from '@angular/material/dialog';

@UntilDestroy()
@Component({
    selector: 'app-contact-view',
    templateUrl: './contact-view.component.html',
    styleUrls: ['./contact-view.component.scss'],
    standalone: false
})
export class ContactViewComponent implements OnInit {
    @Input() listname: string;
    @Input() contactDetail;
    @Input() listDetail;

    @Output() viewContact: EventEmitter<void> = new EventEmitter();
    listSize = 0;
    totalVerifiedContacts = 0;
    totalPendingVerificationContacts = 0;
    suspendedCount: number = 0;
    matched: number = 0;
    fileName;
    type: any;
    readonly accountAttributesEnum: typeof AccountAttributesEnum = AccountAttributesEnum;
    readonly featureFlagsEnum: typeof FeatureFlagsEnum = FeatureFlagsEnum;

    constructor(
        public toastr: ToastrService,
        public contactsService: ContactsService,
        public savedSearches: SavedSearches,
        public commonUtilService: CommonUtilService,
        public rodsService: RoDs,
        public auth: AuthenticationService,
        private companiesService: CompanyService,
        private readonly userService: UserService,
        private readonly requestBodyService: RequestBodyService,
        private readonly matDialog: MatDialog,
    ) {
    }

    ngOnInit(): void {
        if (this.contactDetail) {
            this.listSize = this.contactDetail.total_contacts;
            this.suspendedCount =  this.contactDetail.suspended_count;
            this.matched = this.contactDetail.all_count + this.suspendedCount;
            this.totalVerifiedContacts = this.contactDetail.verified_count;
            this.totalPendingVerificationContacts = this.contactDetail.all_count;
        }
    }

    onViewContact(type: string) {
        let contactData;
        this.requestBodyService.clearSearchSidebar.next(true);
        this.savedSearches.welComeLoadedFlag.next(true);

        contactData = cloneDeep(UniversalSearchModel);
        contactData['location_country_codes'] = [];

        if (type === 'humanVerified') {
            contactData.tiers = '0';
        } else {
            contactData.tiers = this.auth.getPendingTiers().toString();
        }
        contactData.is_international = null;
        contactData['contact_lists'] = [this.listDetail.id];
        contactData['accuracy_tier_contact'] = type === 'machineVerified' ? 'MV' : contactData['accuracy_tier_contact'];
        this.requestBodyService.changeContactBodyData(undefined);
        this.requestBodyService.changeCompanyBodyData(undefined);
        this.commonUtilService.requestBodyUniversalSubscription(contactData);
        this.viewContact.emit();
    }

    onRoDModal(type: 'UNMATCHED' | 'SUSPENDED' | 'machineVerified') {
        if (this.commonUtilService.hasRODCreditsRemaining) {
            this.requestResarch(type);
        } else {
            this.commonUtilService.displayExhaustedRodMessage();
        }
    }

    requestResarch(type : 'UNMATCHED' | 'SUSPENDED' | 'machineVerified') {
        const initialState: MatDialogConfig = {
            panelClass: 'modal-md',
            data: {
                title: 'Request Research',
                labelText: 'Provide your research criteria (title, level, department, etc)',
                placeHolderText: 'Tell us what’s going on with the company(optional).',
                saveButtonText: 'Submit',
                closeButtonText: 'Close',
                inputValue: '',
                mandatoryInput: (!(type === 'UNMATCHED' || type === 'SUSPENDED')),
                isRequestResarch: (type === 'UNMATCHED' || type === 'SUSPENDED')
            }
        };

        this.matDialog.open(RequestResearchModalComponent, initialState).afterClosed().pipe(
            filter((data) => data && data.success),
            switchMap((data) => {
                this.companiesService.isLoader = true;
                if (type === 'UNMATCHED' || type === 'SUSPENDED') {
                    return this.contactsService.requestResearchUnmatched({
                        listId: this.listDetail.id,
                        listType: type,
                        from: 'Portal',
                        title: data.requestName
                    });
                } else {
                    const rodContactType = 'Machine Verified';
                    return this.companiesService.provideFeedback({
                        from: 'Portal',
                        details: '\n\nFileName: ' + this.listDetail.name + '\n\nComment: ' + data.inputValue + '\n\nDetails:\n' + rodContactType + '\n' + this.contactDetail.pending_verification_match_ids,
                        title: data.requestName
                    });
                }
            }),
            untilDestroyed(this)
        ).subscribe((response) => {
            this.setRodData(response);
        }, () => {
            this.companiesService.isLoader = false;
        });
    }

    setRodData(response) {
        this.companiesService.isLoader = false;
        this.rodsService.rodRowData.unshift(response);
        this.rodsService.setRoDs(this.rodsService.rodRowData);
        this.toastr.success('Requested successfully!');
    }

    onExportOriginalRecords(type) {
        let fileName = this.listDetail.name + (type ? '_' + type + '_' + this.commonUtilService.formatDateTime() : '');
        this.contactsService.exportOriginalRecords(this.listDetail.id, type, this.listDetail.name).subscribe((response: any) => {
            if (!fileName && fileName === undefined) {
                fileName = response.headers.get('Content-Disposition').split('attachment; filename=')[1];
            } else {
                fileName = fileName + '.csv';
            }
            const blob = new Blob([response.body], { type: 'text/csv;charset=utf-8' });
            saveAs(blob, fileName);

        }, error => {
            this.commonUtilService.setRevealError(error.status, error.message);
        });
    }
}
